<template>
	<article class="small-12 listing rentListing bgWhite border light borderRadius4 flex vertical-align animated fadeIn" v-bind:class="{ active: isActive }" v-if="rent">
		<div class="small-12 listingWrap flex vertical-align">
			<div class="small-12 large-2 columns flex vertical-align" @click="openEditMenuDropdown()">
				<p class="small-12 text-overflow">
					<span class="badge bgPrimaryBlue borderRadius4" v-if="rent.attributes.term == 'current'">Current</span>
					<span class="badge bgSecondaryPurple borderRadius4" v-else-if="rent.attributes.term == 'past'">Past</span>
					<span class="badge bgGrey borderRadius4" v-else>Future</span>
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align" @click="openEditMenuDropdown()">
				<p class="small-12 text-overflow">
					{{rent.attributes.term_dates.starting_at | unixToDate}}
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align" @click="openEditMenuDropdown()">
				<p class="small-12 text-overflow">
					{{rent.attributes.term_dates.ending_at | unixToDate}}
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align" @click="openEditMenuDropdown()">
				<p class="small-12 text-overflow" v-if="rent.attributes.policy.cycle == 'monthly'">
					Monthly
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align" @click="openEditMenuDropdown()">
				<p class="small-12 text-overflow">
					${{rent.attributes.amount | convertCentsToDollars}}
				</p>
			</div>
			<div class="small-2 actions flex justify-right">
				<a class="border borderRadius4 flex vertical-align justify-center edit" @click="showEditRentMenu()" v-tooltip="'Edit Rent'">
					<i class="material-icons">edit</i>
				</a>
				<a class="border bgOffsetGrey borderRadius4 flex vertical-align justify-center" @click="openEditMenuDropdown()">
					<i class="material-icons-outlined" v-if="!openMenuDropdown">expand_more</i>
					<i class="material-icons-outlined" v-else>expand_less</i>
				</a>
			</div>
		</div>
		<div class="small-12 openuEditViewMenu animated fadeIn" v-if="openMenuDropdown">
			<div class="small-12 large-6 columns title flex vertical-align">
				<div class="small-12 flex vertical-align">
					<h2 v-if="start_year !== end_year">{{start_year}}-{{end_year}}</h2>
					<h2 v-else>Rent Term: {{start_year}}</h2>
					<i class="round flex"></i>
					<span class="badge borderRadius4 flex">{{total_months}} months</span>
				</div>
			</div>
			<div class="small-12 large-6 columns financialInfo flex vertical-align">
				<div class="small-12 earnings">
					<p class="small-12 text-overflow flex justify-between vertical-align">
						<b class="flex vertical-align">
							Money In 
							<small>(To Date)</small>:
						</b> 
						<span>${{rent.metrics.total_paid_amount | convertCentsToDollars}} / ${{rent.metrics.total_balance | convertCentsToDollars}}</span>
					</p>
				</div>
			</div>
			<div class="small-12 columns">
				<div class="small-12 stackedBarGauge">
					<ul class="flex vertical-align borderRadius50">
						<li class="properties bgPrimaryBlue" :style="'width:' + moneyInGaugePercent + '%;'" v-tooltip="'Total Percentage Earned: ' + moneyInGaugePercent + '%'"></li>
					</ul>
				</div>
			</div>
			<div class="small-12 deets border-top">
				<div class="small-12 large-4 columns deetColumn">
					<div class="small-12 viewEditTitle">
						<h4>Create Invoices</h4>
					</div>
					<div class="small-12 actions bgOffsetGrey borderRadius8 flex vertical-align">
						<ul class="flex float-left small-12">
							<li class="small-12 flex justify-center">
								<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openCreateInvoiceMenu()" v-if="rent.attributes.term !== 'past'">
									<i class="material-icons-outlined flex vertical-align justify-center">add</i>
									Create Invoice
								</a>
								<a class="disabledButton flex vertical-align justify-center borderRadius4" v-else>
									<i class="material-icons-outlined flex vertical-align justify-center">add</i>
									Create Invoice
								</a>
							</li>
							<li class="small-12 flex justify-center separator">
								<span class="flex justify-center">or</span>
							</li>
							<li class="small-12 flex justify-center">
								<a class="disabledButton flex justify-center vertical-align borderRadius4">
									<i class="material-icons-outlined flex vertical-align justify-center">add_to_photos</i>
									Auto-Create
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="small-12 large-8 deetColumn">
					<div class="small-12 large-8 flex border-right columnWrap">
						<div class="small-12 large-6 columns statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Status</h4>
							</div>
							<div class="small-12 status flex">
								<span class="badge bgPrimaryBlue borderRadius4" v-if="rent.attributes.status == 'current'">Current</span>
								<span class="badge bgRed borderRadius4" v-else-if="rent.attributes.status == 'late'">Late</span>
								<span class="badge bgSecondaryPurple borderRadius4" v-else-if="rent.attributes.status == 'complete'">Complete</span>
								<span class="badge bgGrey borderRadius4" v-else>Not Started</span>
							</div>
						</div>
						<div class="small-12 large-6 statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Total Invoices</h4>
							</div>
							<div class="small-12 rentCycle">
								<p class="small-12 text-overflow">
									{{rent.metrics.total_created_invoices}}/{{rent.metrics.total_charges}}
								</p>
							</div>
						</div>
						<div class="small-12 large-6 columns statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Due By</h4>
							</div>
							<div class="small-12 dueBy">
								<p class="small-12 text-overflow" v-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.due_on % 10 == 1">
									{{rent.attributes.policy.due_on}}st/mo.
								</p>
								<p class="small-12 text-overflow" v-else-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.due_on % 10 == 2">
									{{rent.attributes.policy.due_on}}nd/mo.
								</p>
								<p class="small-12 text-overflow" v-else-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.due_on % 10 == 3">
									{{rent.attributes.policy.due_on}}rd/mo.
								</p>
								<p class="small-12 text-overflow" v-else-if="rent.attributes.policy.cycle == 'monthly'">
									{{rent.attributes.policy.due_on}}th/mo.
								</p>
							</div>
						</div>
						<div class="small-12 large-6 statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Late By</h4>
							</div>
							<div class="small-12 dueBy">
								<p class="small-12 text-overflow" v-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.late_by % 10 == 1">
									{{rent.attributes.policy.late_by}}st/mo.
								</p>
								<p class="small-12 text-overflow" v-else-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.late_by % 10 == 2">
									{{rent.attributes.policy.late_by}}nd/mo.
								</p>
								<p class="small-12 text-overflow" v-else-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.late_by % 10 == 3">
									{{rent.attributes.policy.late_by}}rd/mo.
								</p>
								<p class="small-12 text-overflow" v-else-if="rent.attributes.policy.cycle == 'monthly' && rent.attributes.policy.late_by">
									{{rent.attributes.policy.late_by}}th/mo.
								</p>
								<p class="small-12 text-overflow" v-else>
									--
								</p>
							</div>
						</div>
						<div class="small-12 large-6 columns statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Invoices Late</h4>
							</div>
							<div class="small-12 invoicesLate">
								<p class="small-12 text-overflow">
									{{rent.metrics.total_late}}
								</p>
							</div>
						</div>
						<div class="small-12 large-6 statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Invoices Paid</h4>
							</div>
							<div class="small-12 invoicesLate">
								<p class="small-12 text-overflow">
									{{rent.metrics.total_paid}}
								</p>
							</div>
						</div>
						<div class="small-12 large-6 columns statContainer" v-if="payment_method_set && rent.attributes.transaction_fees_policy.set_policy">
							<div class="small-12 viewEditTitle">
								<h4>Transaction Fee Policy</h4>
							</div>
							<div class="small-12 invoicesLate">
								<p class="small-12 text-overflow" v-if="rent.attributes.transaction_fees_policy.method_type == 'owner'">
									Owner
								</p>
								<p class="small-12 text-overflow" v-else>
									Resident
								</p>
							</div>
						</div>
					</div>
					<div class="small-12 large-4 columns deetColumn">
						<div class="small-12 statContainer">
							<div class="small-12 viewEditTitle">
								<h4 v-if="rent.attributes.policy.cycle == 'monthly'">Rent</h4>
							</div>
							<div class="small-12 amount">
								<p>${{rent.attributes.amount | convertCentsToDollars}}</p>
							</div>
						</div>
						<div class="small-12 statContainer" v-if="payment_method_set && rent.attributes.transaction_fees_policy.set_policy">
							<div class="small-12 viewEditTitle">
								<h4>Transaction Fee</h4>
							</div>
							<div class="small-12 amount">
								<p class="small-12 text-overflow" v-if="rent.attributes.transaction_fees_policy.method_type == 'resident'">
									${{rent.attributes.transaction_fees_policy.resident.fee_amount | convertCentsToDollars}}
								</p>
								<p class="small-12 text-overflow" v-else>
									100%
								</p>
							</div>
						</div>
						<div class="small-12 statContainer">
							<div class="small-12 viewEditTitle">
								<h4>Late Fee</h4>
							</div>
							<div class="small-12 amount">
								<p class="small-12 text-overflow">
									${{rent.attributes.policy.late_fee | convertCentsToDollars}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="small-12 columns invoices border-top">
				<div class="small-12 viewEditTitle flex vertical-align">
					<h4>Total Invoices</h4>
					<span class="round totalCount bgPrimaryBlue flex vertical-align justify-center">
						{{invoices.length}}
					</span>
				</div>
				<div class="small-12 table">
					<div class="small-12 tableHeader">
						<ul class="small-12 float-left tableRow flex">
							<li class="small-3 tableCell">
								<p class="small-12 text-overflow">
									Due On
								</p>
							</li>
							<li class="small-2 tableCell">
								<p class="small-12 text-overflow">
									Status
								</p>
							</li>
							<li class="small-2 tableCell">
								<p class="small-12 text-overflow">
									Total
								</p>
							</li>
							<li class="small-3 tableCell">
								<p class="small-12 text-overflow" v-if="payment_method_set && company.attributes.settings.payment_methods.cards && company.attributes.settings.payment_methods.ach">
									Card Fee / ACH Fee<em class="cPrimary">*</em>
								</p>
								<p class="small-12 text-overflow" v-else-if="payment_method_set && company.attributes.settings.payment_methods.cards">
									Card Fee<em class="cPrimary">*</em>
								</p>
								<p class="small-12 text-overflow" v-else-if="payment_method_set && company.attributes.settings.payment_methods.ach">
									ACH Fee<em class="cPrimary">*</em>
								</p>
								<p class="small-12 text-overflow" v-else>
									Late Fee Applied
								</p>
							</li>
							<li class="small-2 tableCell actions"></li>
						</ul>
					</div>
					<div class="small-12 tableBody" v-if="invoices && invoices.length > 0">
						<ul class="small-12 float-left tableRow flex vertical-align border-bottom transition" v-for="(invoice, index) in invoices" :key="index">
							<li class="small-3 tableCell">
								<p class="small-12 text-overflow flex vertical-align">
									<span class="round monthBadge bgPrimaryBlue flex justify-center vertical-align">{{ invoice.attributes.due_on.date | unixToMonthShorthand }}</span>
									{{ invoice.attributes.due_on.date | unixToDate }}
								</p>
							</li>
							<li class="small-2 tableCell">
								<p class="small-12 text-overflow">
									<span class="badge bgGrey borderRadius4" v-if="invoice.attributes.status == 'draft'">Draft</span>
									<span class="badge bgYellow borderRadius4" v-else-if="invoice.attributes.status == 'open'">Open</span>
									<span class="badge bgGreen borderRadius4" v-else-if="invoice.attributes.status == 'paid'">Paid</span>
									<span class="badge bgPurple borderRadius4" v-else-if="invoice.attributes.status == 'uncollectible'">Void</span>
									<span class="badge bgGrey borderRadius4" v-else-if="invoice.attributes.status == 'pending'">Pending</span>
									<span class="badge bgRed borderRadius4" v-else>Late</span>
								</p>
							</li>
							<li class="small-2 tableCell">
								<p class="small-12 text-overflow">
									${{ invoice.attributes.charge.total | convertCentsToDollars }}
								</p>
							</li>
							<li class="small-3 tableCell" v-if="payment_method_set">
								<p class="small-12 text-overflow" v-if="company.attributes.settings.payment_methods.cards && company.attributes.settings.payment_methods.ach">
									$-{{ invoice.attributes.charge.card_fees.total_fees | convertCentsToDollars }} / $-{{ invoice.attributes.charge.ach_fees.total_fees | convertCentsToDollars }}
								</p>
								<p class="small-12 text-overflow" v-else-if="company.attributes.settings.payment_methods.cards">
									$-{{ invoice.attributes.charge.card_fees.total_fees | convertCentsToDollars }}
								</p>
								<p class="small-12 text-overflow" v-else-if="company.attributes.settings.payment_methods.ach">
									$-{{ invoice.attributes.charge.ach_fees.total_fees | convertCentsToDollars }}
								</p>
							</li>
							<li class="small-3 tableCell" v-else>
								<p class="small-12 text-overflow" v-if="invoice.attributes.status == 'late'">
									${{ invoice.attributes.charge.policy_late_fee | convertCentsToDollars }}
								</p>
								<p class="small-12 text-overflow" v-else>
									$0.00
								</p>
							</li>
							<li class="small-2 tableCell actions flex justify-right">
								<a class="border borderRadius4 flex vertical-align justify-center viewInvoiceButton" @click="openViewInvoiceMenu(invoice)" v-tooltip="'View'">
									<i class="material-icons">navigate_next</i>
								</a>
							</li>
						</ul>
					</div>
					<div class="small-12 tableBody" v-else>
						<ul class="small-12 columns flex animated fadeIn">
							<li class="small-12">
								<div class="small-12 emptyResults flex justify-center">
									<picture class="small-12 flex justify-center vertical-align">
										<img width="120" :src="empty_image" alt="Nestd Logo in a House">
									</picture>
									<h6 class="small-12 text-center">
										0 results found
									</h6>
									<p class="small-12 text-center">
										No invoices have been added to this rent term yet.
									</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="small-12 tableFooter">
						<small><em class="cPrimary">*</em> Card and ACH transaction fees are estimates only. Actual fees may vary once the payment has been finalized.</small>
					</div>
				</div>
			</div>
		</div>
	</article>
</template>

<script>

	// Import firebase
	import { firebaseAuth, propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Rent',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			DatesFilters,
			MoneyConversions

		],

		/*
		**  Set the props
		*/

		props: {

			rent: {
				type: Object,
				default: () => null
			},

			lease: {
				type: Object,
				default: () => null
			},

			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			openMenuDropdown: false,
			isActive: false,
			future_item: false,
			selected_rent: null,
			invoices: null,
			total_months: null,
			start_year: null,
			end_year: null,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			active_invoice: null,
			payment_method_set: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			rent: {

				immediate: true, // Load on created
				handler(rent) {

					if (rent) {

						/*
						**  Get the duration
						**  @method: @here
						*/

						this.getRentTermDuration();

						/*
						**  Bind the existing invoices
						**  @method: @here
						*/

						this.bindToTheInvoices();

					}

				}

			},

			company: {

				immediate: true, // Load on created
				handler(company) {

					if (company) {
 
						/*
						**  Check if payment methods have been set
						**  @method: @here
						*/

						this.checkPaymentMethods();

					}

				}

			}

		},

        /*
		**  Set up the methods
		*/

		methods: {

			checkPaymentMethods: function() {

				try {

					/*
					**  Check if payment methods have been set
					**  @method: @here
					*/

					if (this.company.attributes.settings.payment_methods.cards || this.company.attributes.settings.payment_methods.ach) this.payment_method_set = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Check if payment methods have been set within a rent term.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'KaivAAfW7fDhoAFh2Fuj',
						error: e
					});

				}

			},

			showEditRentMenu: function() {

				try {
 
					/*
					**  Emit the event
					**  @service: @Vue
					*/

					this.$emit('openEditRentMenu', this.rent);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the open edit rent modal event.',
						errorType: 'Application',
						section: 'Rent',
						uid: '7bKE8wEzzOvOwEuYwahu',
						error: e
					});

				}

			},

			openEditMenuDropdown: function() {

				try {

					if (!this.openMenuDropdown) {
 
						/*
						**  Open menu
						**  @prop: @here
						*/

						this.openMenuDropdown = true;
 
						/*
						**  Set the z-index of the unit
						**  @prop: @here
						*/

						this.isActive = true;

					} else {

						/*
						**  Open menu
						**  @prop: @here
						*/

						this.openMenuDropdown = false;

						/*
						**  Set the z-index of the unit
						**  @prop: @here
						*/

						this.isActive = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Open the Rent Term Menu.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'bT84krh8eOXoqMnzRVq9',
						error: e
					});

				}

			},

			closeEditMenuDropdown: function(e) {

				try {

					if (!this.$el.contains(e.target)) {

						/*
						**  Close menu
						**  @prop: @here
						*/

						this.openMenuDropdown = false;

						/*
						**  Set the z-index of the unit
						**  @prop: @here
						*/

						this.isActive = false;

					}

				} catch (error) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the Rent Term Menu.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'y7Jh1gIQIIRRKdf7bKIc',
						error: error
					});

				}

			},
			
			openCreateInvoiceMenu: function() {

				try {
 
					/*
					**  Emit the event
					**  @service: @Vue
					*/

					this.$emit('openCreateInvoiceMenu', this.rent);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the open create invoice menu event.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'pU2amrmN0Mddyw7TCNwz',
						error: e
					});

				}

			},

			getRentTermDuration: function() {

				try {

					/*
					**  Set the props
					**  @props: @here
					*/

					this.start_year = moment(this.rent.attributes.term_dates.starting_at * 1000).format('YYYY');
					this.end_year = moment(this.rent.attributes.term_dates.ending_at * 1000).format('YYYY');
					this.total_months = moment(this.rent.attributes.term_dates.ending_at * 1000).diff(moment(this.rent.attributes.term_dates.starting_at * 1000), 'months') + 1;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Get rent term duration in rent term.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'D0lsRsEwIjDDhb7WjqYA',
						error: e
					});

				}

			},

			openViewInvoiceMenu: function(invoice) {

				try {
 
					/*
					**  Emit the event
					**  @service: @Vue
					*/

					this.$emit('openViewInvoiceMenu', invoice);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the open view invoice menu event.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'IDYZbjexhOPaAuGyUVVZ',
						error: e
					});

				}

			},

			bindToTheInvoices: function() {

				try {

					/*
					**  Bind the existing invoices
					**  @service: @VueFire
					*/

					this.$bind('invoices', propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(this.rent.id).collection('invoices').where('meta.deleted_at', '==', null).orderBy('attributes.due_on.date', 'asc'));

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Bind to the invoices within a rent term.',
						errorType: 'Application',
						section: 'Rent',
						uid: '80t1k7Tb8IaVtCuTLt6L',
						error: e
					});

				}

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			moneyInGaugePercent: function() {

				let percent = 0;

				if (this.rent.metrics.total_paid_amount > 0) percent = ((this.rent.metrics.total_paid_amount / this.rent.metrics.total_balance) * 100).toFixed(0);

				return percent;

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>